import "./instrument.js";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";

//**  Context */
import NewBusinessState from "./context/newBusiness/newBusinessState";
import PreQualificationState from "./context/preQualification/preQualificationState";
import PreQualificationPagesState from "./context/preQualPages/preQualificationPagesState";
import SharedDataState from "./context/sharedData/sharedDataState";

import { PaymentProvider } from "./context/BraintreeContext.jsx";

// import { ErrorBoundary } from "react-error-boundary";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { Fallback } from "./components/Fallback";
import AuthState from "./context/auth/authState";

import "./feedbackform.css";

const errorHandler = (error, errorInfo) => {
	// console.log("Logging ", error, errorInfo);
	// Log error? Sentry?
	Sentry.captureException(new Error(error));
	Sentry.captureMessage(errorInfo);
};

if (import.meta.env.MODE === "production") {
	// replace console.* for disable log on production
	//----------------------------------------------------------------
	console.log = () => {};
	console.error = () => {};
	console.debug = () => {};
}

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<Sentry.ErrorBoundary fallback={Fallback} showDialog onError={errorHandler}>
			<HelmetProvider>
				<BrowserRouter>
					<AuthState>
						<PaymentProvider>
							<NewBusinessState>
								<PreQualificationState>
									<PreQualificationPagesState>
										<SharedDataState>
											<App />
										</SharedDataState>
									</PreQualificationPagesState>
								</PreQualificationState>
							</NewBusinessState>
						</PaymentProvider>
					</AuthState>
				</BrowserRouter>
			</HelmetProvider>
		</Sentry.ErrorBoundary>
	</React.StrictMode>
);
